import style from "./style.module.scss";
import editImg from './Edit.png';
import arrowImg from '../Arrow.png';
import mobileImg from "../loginPage/mobile.png";
import { useEffect, useRef, useState } from "react";
import { fancyTimeFormat } from "../../../../../Panel/Common/Function";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { VerifyCode, ResendVerifyCode } from "../../../../../Web/View/Auth/Components/Services";
const ConfirmaNumber = ({ step, setStep, isLogin, setisLogin, isWebview }) => {
    const [CodeSms, setCodeSms] = useState([null, null, null, null, null]);
    const [Code, setCode] = useState([null, null, null, null, null]);
    const [Timer, setTimer] = useState(120);
    const location = useLocation();
    const dispatch = useDispatch();
    const { mobile } = useSelector(state => state);

    let initialState = {
        mobile: location.state ? location.state.mobile : mobile,
        veryfyCode: null
    }
    const [state, setState] = useState(initialState);
    useEffect(() => {
        ref1.current.focus();
    }, [])

    const TimerCode = () => {
        setTimeout(() => {
            if (Timer >= 1) {
                setTimer(Timer - 1)
            }
        }, 1000);
    }

    TimerCode();

    const CodeHandel = (mobile, veryfyCode) => {
        if (state.veryfyCode !== null) {
            console.log(veryfyCode);
            VerifyCode(mobile, veryfyCode).then(result => {
                if (result) {
                    dispatch({
                        local_storage: {
                            key: "user",
                        },
                        payload: "user",
                        type: "REMOVE",
                    });
                    dispatch({
                        local_storage: {
                            key: "user",
                            value: result,
                        },
                        payload: { user: result },
                        type: "SET",
                    });
                    dispatch({
                        local_storage: {
                            key: "user_type",
                            value: result.role,
                        },
                        payload: { user_type: result.role },
                        type: "SET",
                    });
                    if (result.status === "active") {
                        if (isWebview) {
                            setisLogin(true)
                        }
                        else {
                            location.reload();
                        }
                    }
                }
            });
        }
    }

    const ResendCodeHandel = (mobile) => {
        ResendVerifyCode(mobile).then(result => {
            setState({
                ...state,
                result: result
            })
        })
    }

    const ref1 = useRef();
    const ref2 = useRef();
    const ref3 = useRef();
    const ref4 = useRef();
    const ref5 = useRef();

    const SmsHandler = (e, index, ref) => {
        let NewData = CodeSms;
        NewData[index] = e.target.value;
        setCodeSms(NewData);
        setCode(NewData);
        setState(() => ({ ...state, veryfyCode: Code.join("") }))

        e.target.value &&
            ref != "r5" ? ref.current.focus() : ref4.current.blur()
    }
    const resetTimer = () => {
        ResendCodeHandel(state.mobile);
        setTimer(() => 120)
    }
    return (
        <>
            <section>
                <div className={style.headText}>
                    <img src={arrowImg} onClick={() => setStep("step2")} className={style.arrowIcon} alt="arrowIcon" />
                    <h3 className={style.titelText}>تایید شماره همراه</h3>
                </div>
                <div>
                    <p className={style.warn}>لطفا کد 5 رقمی که برای شما ارسال شده است را وارد نمایید.</p>
                    <div className={style.boxEdit}>
                        <div className={style.boxNumber}>
                            <img src={mobileImg} className={style.mobileIcon} alt="mobileIcon" />
                            <p >{mobile}</p>
                        </div>
                        <img src={editImg} onClick={() => setStep("step2")} className={style.editIcon} alt="editIcon" />
                    </div>
                    <div className={style.parentInput}>
                        <input ref={ref1} maxLength={5} onChange={(e) => SmsHandler(e, 0, ref2)} className={style.input} type="number" />
                        <input ref={ref2} maxLength={5} onChange={(e) => SmsHandler(e, 1, ref3)} className={style.input} type="number" />
                        <input ref={ref3} maxLength={5} onChange={(e) => SmsHandler(e, 2, ref4)} className={style.input} type="number" />
                        <input ref={ref4} maxLength={5} onChange={(e) => SmsHandler(e, 3, ref5)} className={style.input} type="number" />
                        <input ref={ref5} maxLength={5} onChange={(e) => SmsHandler(e, 4, "r5")} className={style.input} type="number" />
                    </div>
                    <div className={"mb-4 " + style.parentBtn}>
                        <button className={style.btn} style={{ background: Timer < 1 ? 'gray' : '#E42A3F' }} disabled={Timer < 1 ? "disabled" : null} onClick={() => CodeHandel(state.mobile, state.veryfyCode)}>
                            تایید
                        </button>
                    </div>
                    {
                        Timer > 0 ?
                            <p className={style.showTime}> زمان باقی مانده : {fancyTimeFormat(Timer)}</p>
                            :
                            <p className={style.showTime} onClick={() => resetTimer()} >ارسال مجدد کد</p>
                    }
                    {/* <p className={style.endText} style={{ paddingTop: "5px" }}> پیش از این ثبت نام کرده اید ؟ <span onClick={() => setStep("step3")} style={{ color: "#E42A3F", padding: "0 0 10px 0", border: "none" }}> صفحه ورود </span></p> */}
                </div>
            </section>
        </>
    );
}

export default ConfirmaNumber;